import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TArticleDM from './TArticleDM'
import RelatedGoodsType from './RelatedGoodsType'

export default class TEshopRelatedArticleDM extends Data {
	public static className = 'TEshopRelatedArticleDM'
	public static primaryKey = 'RID'
	public static systemFields = [
		'RecordID',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.RID!
	}

	RID?: number
	SequenceNumber?: number
	MeasureUnitId?: number
	Quantity?: number
	MasterArticleId?: number
	RecordMod?: number
	RecordES?: number
	RecordID?: number
	RecordState?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	@Type(() => TArticleDM)
	ArticleId?: TArticleDM
	@Type(() => RelatedGoodsType)
	RelationTypeId?: RelatedGoodsType
}